import { parseU64, parseU64OrZero } from "@bridgesplit/utils";

import { EarnActivityItemApi, EarnActivityResponseApi } from "../api/earn-activity";
import { EarnActivityItem, EarnActivityResponse } from "../domain/earn-activity";

function parseEarnActivityItemFromApi(api: EarnActivityItemApi): EarnActivityItem {
    return {
        ...api,
        requestAddress: api.requestAddress ?? undefined,
        assets: parseU64(api.assets) ?? undefined,
        shares: parseU64(api.shares) ?? undefined,
        feesAssets: parseU64OrZero(api.feesAssets)
    };
}

export function parseEarnActivityResponseFromApi(
    api: EarnActivityResponseApi | EarnActivityItemApi[]
): EarnActivityResponse {
    const items = Array.isArray(api) ? api : api.items ?? [];
    const pageInfo = Array.isArray(api)
        ? {
              page: 0,
              pageSize: items.length,
              totalItems: items.length,
              totalPages: 1
          }
        : api.pageInfo ?? {
              page: 0,
              pageSize: items.length,
              totalItems: items.length,
              totalPages: 1
          };

    return {
        items: items.map(parseEarnActivityItemFromApi),
        pageInfo
    };
}
